export default function AboutSection() {
  return (
    <section id="about" className="relative py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-information-line"></i>
            关于我们
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-6">
            关于青青草视频
          </h2>

          <div className="bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/70 text-left">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              青青草视频是一个专注于在线视频平台资源聚合的导航网站。我们致力于为用户提供便捷、高效、安全的一站式视频平台入口服务。目前，青青草视频已收录久久视频、芒果视频、97视频、丝瓜视频、蓝莓视频、91在线视频、糖心视频、黑桃视频等多个主流在线视频平台，并持续扩展更多优质视频网站资源。
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              我们的团队每日更新各平台的内容入口与最新资讯，确保用户能够在青青草视频上获取最新、最全的视频资源导航信息。无论您是在寻找最新热播剧集、独家综艺节目、经典电影回顾，还是探索小众特色视频内容，都能在这里找到适合的平台入口。
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              青青草视频坚持绿色安全的上网理念，所有收录的平台入口均经过人工审核。我们注重用户体验的每一个细节，从页面加载速度到移动端适配，持续优化迭代。如果您有任何建议或合作意向，欢迎随时通过联系我们页面与我们沟通。
            </p>

            <div className="flex flex-wrap items-center justify-center gap-4 pt-4 border-t border-background-200/70">
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-check-double-line text-primary-500"></i>
                安全审核
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-time-line text-accent-500"></i>
                每日更新
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-user-heart-line text-secondary-500"></i>
                用户至上
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}